import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";
import { RatingSummary, SavingsTag } from "@/components/Stars";
import { WishButton } from "@/components/WishButton";

export const ProductCard = ({ p, index }) => {
  const { add } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06, duration: 0.4 }}
      className="brut-hover bg-white border border-[#0F0F0F] flex flex-col"
      data-testid={`product-card-${p.id}`}
    >
      <Link to={`/prodotto/${p.id}`} className="relative block aspect-square overflow-hidden border-b border-[#0F0F0F]" data-testid={`product-link-${p.id}`}>
        <img src={p.image} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
        {p.discount > 0 && (
          <span className="absolute top-3 left-3 bg-[#FF3333] text-white tag px-2 py-1">-{p.discount}%</span>
        )}
        <WishButton id={p.id} className="absolute top-3 right-3" />
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <span className="tag text-[#555]">{p.category}</span>
        <Link to={`/prodotto/${p.id}`} className="mt-2 font-medium leading-snug line-clamp-2 hover:text-[#FF3333]">{p.title}</Link>
        <div className="mt-2"><RatingSummary p={p} /></div>
        <div className="mt-auto pt-4 flex items-end justify-between gap-2">
          <div>
            {p.list_price && <p className="font-mono text-xs text-[#555] line-through">{eur(p.list_price)}</p>}
            <p className="font-display font-black text-2xl tracking-tight" data-testid={`product-price-${p.id}`}>{eur(p.price)}</p>
            <SavingsTag p={p} />
          </div>
          <button
            data-testid={`add-to-cart-${p.id}`}
            onClick={() => { add(p); toast.success("Aggiunto al carrello"); }}
            className="btn-ghost tag px-3 py-2"
          >
            + Carrello
          </button>
        </div>
      </div>
    </motion.div>
  );
};
